import type {EditorState, Transaction} from "prosemirror-state";
import {EditorView} from "prosemirror-view";

import type {TableContextMenuParams} from "../../../../ui/elements/context-menu/editor/TableToolbar/openTableContextMenu";

import {findTablePosByTargetPos} from "../../../utils/findTablePos";
import {setNodeAttribute} from "../../../utils/setNodeAttribute";

export const maximizeTable = (state: EditorState, dispatch?: (tr: Transaction) => void, view?: EditorView, params?: TableContextMenuParams) => {
    let targetPos = state.selection.$from.pos;
    if (params?.clickPos) {
        targetPos = params.clickPos;
    }
    const tableNodePos = findTablePosByTargetPos(state.doc.resolve(targetPos));
    if (tableNodePos === undefined) {
        return false;
    }

    if (dispatch) {
        const tableNode = state.doc.nodeAt(tableNodePos);
        setNodeAttribute(state, tableNode!, tableNodePos, 'state', 'maximized', dispatch);
    }
    return true
}

export const canMaximizeTable = (state: EditorState, params?: TableContextMenuParams) => {
    let targetPos = state.selection.$from.pos;
    if (params?.clickPos) {
        targetPos = params.clickPos;
    }
    const tableNodePos = findTablePosByTargetPos(state.doc.resolve(targetPos));
    if (tableNodePos === undefined) {
        return false;
    }
    const tableNode = state.doc.nodeAt(tableNodePos)!;
    return tableNode.attrs.state !== 'maximized';
}
